<!--
  综合活动 - 确认名单
-->
<template>
  <div class="SubWebPage" v-loading.fullscreen.lock="fullscreenLoading">
    <!--   <search :SearchTitles="SearchTitles" :ColNumber="3" :SearchList="SearchList" ref="SearchList" @onSearch="onSearch"
      v-if="SearchList!=null"></search> -->
    <!-- 列表-->
    <el-card class="box-card">
      <div slot="header" class="card-header">
        <h3 class="card-title titleCont">
          <span class="spIcon"></span>
          {{ Title }}
        </h3>
        <div class="card-tools">
          <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            :disabled="isBatchDelete"
            @click="onBatchDel()"
            >批量移除</el-button
          >
        </div>
        <div
          class="card-tools"
          style="margin-right: 0px"
          v-if="activityData.joinType == 1"
        >
          <comImport
            v-if="ImportFile != null && ImportUrl != null"
            @onImportSuccess="onImportSuccess"
            :title="ImportTitle"
            :template="ImportFile"
            :path="ImportUrl"
            ref="conImportFile"
            :btnSize="'small'"
            :btnName="'导入名单'"
          >
          </comImport>
        </div>
        <div class="card-tools" style="margin-right: 5px">
          <el-button
            size="small"
            type="success"
            icon="el-icon-circle-plus-outline"
            @click="onAdd()"
            >选择名单</el-button
          >
        </div>
      </div>
      <div class="card-body p-0" v-if="!regNullArray(itemData)">
        <div class="table-box" :style="'height: ' + windowHeight + 'px;'">
          <table class="table-body">
            <!-- 标题 -->
            <tr class="tr-head">
              <td width="40px">&nbsp;</td>
              <td width="80px" align="center">序号</td>
              <td width="15%">班级</td>
              <td class="">学号</td>
              <td class="">学生</td>
              <td class="" v-if="activityData.joinType == 1">角色</td>
              <td class="">报名时间</td>
              <td class="" v-if="activityData.isAttendance">签到</td>
              <td class="" width="160px" v-if="activityData.isUpload">
                上传（点击图片浏览）
              </td>
              <td class="" width="120px">是否计入综合分</td>
              <td width="80px" class="t-c">操作</td>
            </tr>
            <!-- 表格内容 -->
            <tr class="tr-body" v-for="(item, index) in itemData" :key="index">
              <td width="40px" class="td-checkbox" align="center">
                <span class="btn-disable" v-if="item.scoring">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#fax-square-radius-o"></use>
                  </svg>
                </span>
                <span v-else @click="onCheckDelType(item)">
                  <svg
                    class="icon color-primary"
                    aria-hidden="true"
                    v-if="item.delType == true"
                  >
                    <use xlink:href="#fax-square-check-alt"></use>
                  </svg>
                  <svg class="icon" aria-hidden="true" v-else>
                    <use xlink:href="#fax-square-radius-o"></use>
                  </svg>
                </span>
              </td>
              <td align="center">{{ index + 1 }}</td>
              <td>{{ item.className }}</td>
              <td>
                {{ regNull(item.studentNo) ? '/' : item.studentNo }}
              </td>
              <td>
                {{ regNull(item.studentName) ? '/' : item.studentName }}
              </td>
              <td v-if="activityData.joinType == 1">
                <div v-if="item.scoring">{{ item.roleName }}</div>
                <div v-else class="td-select-box" @click="onClickRole(item)">
                  <span class="flex-grow-1"> {{ item.roleName }}</span>
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-angle-down"></use>
                    </svg>
                  </span>
                </div>
              </td>
              <td>
                {{ item.applyDate | dateformatMinute }}
              </td>
              <td v-if="activityData.isAttendance">
                <svg class="icon" aria-hidden="true" v-if="item.attended">
                  <use xlink:href="#fax-circle-check-o"></use>
                </svg>
                <svg class="icon" aria-hidden="true" v-else>
                  <use xlink:href="#fax-times-circle-o"></use>
                </svg>
              </td>
              <td v-if="activityData.isUpload">
                <div v-if="!regNullArray(item.images)" class="t-c">
                  <el-image
                    style="width: 24px; height: 24px"
                    :src="item.images[0]"
                    :preview-src-list="item.images"
                  >
                  </el-image>
                </div>
                <div class="color-gray" v-else>无上传附件</div>
              </td>
              <td width="130px">
                <div v-if="item.scoring" class="t-c">
                  <span class="color-primary" v-if="item.status == 3">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-circle-check"></use>
                    </svg>
                  </span>
                  <span class="color-gray" v-else-if="item.status == 2">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#fax-times-circle"></use>
                    </svg>
                  </span>
                </div>
                <div v-else class="td-status">
                  <div
                    class="td-status-item VerticalLeft"
                    :class="item.status == 3 ? 'td-status-action' : ''"
                    @click="onIsStatus(item, true)"
                  >
                    <svg class="icon td-status-yes" aria-hidden="true">
                      <use xlink:href="#fax-dot-circle-o"></use>
                    </svg>
                    <svg class="icon td-status-no" aria-hidden="true">
                      <use xlink:href="#fax-circle-o"></use>
                    </svg>
                    是
                  </div>
                  <div
                    class="td-status-item VerticalLeft"
                    :class="item.status == 2 ? 'td-status-action' : ''"
                    @click="onIsStatus(item, false)"
                  >
                    <svg class="icon td-status-yes" aria-hidden="true">
                      <use xlink:href="#fax-dot-circle-o"></use>
                    </svg>
                    <svg class="icon td-status-no" aria-hidden="true">
                      <use xlink:href="#fax-circle-o"></use>
                    </svg>
                    否
                  </div>
                </div>
              </td>
              <td class="t-c">
                <span
                  class="btn btn-danger btn-xs btn-disable"
                  v-if="item.scoring"
                >
                  移除
                </span>
                <span
                  class="btn btn-danger btn-xs"
                  @click="onDeleteRoster(item)"
                  v-if="!item.scoring"
                >
                  移除
                </span>
              </td>
            </tr>
          </table>
        </div>
        <comPage :paging="paging" :isPage="false"> </comPage>
      </div>
      <div class="card-body" v-else>
        <el-empty :image-size="200" description="暂无数据" name="3"></el-empty>
      </div>
    </el-card>

    <div class="row" style="margin-top: 10px">
      <div class="col-6">
        <el-button icon="el-icon-back" @click="onBack()">返回</el-button>
        <el-button @click="onCheckAll">
          <svg class="icon" aria-hidden="true" v-if="iconAllCheck == 0">
            <use xlink:href="#fax-square-radius-o"></use>
          </svg>
          <svg
            class="icon color-primary"
            aria-hidden="true"
            v-else-if="iconAllCheck == 2"
          >
            <use xlink:href="#fax-square-check-alt"></use>
          </svg>
          <svg class="icon color-primary" aria-hidden="true" v-else>
            <use xlink:href="#fax-minus-square-o"></use>
          </svg>
          全选
        </el-button>
        <el-button
          slot="reference"
          type="primary"
          icon="el-icon-circle-check"
          @click="onSave()"
          >计入综合分</el-button
        >
      </div>
      <div class="col-6 text-right"></div>
    </div>
    <el-dialog
      :title="'选择班级'"
      :visible.sync="dialogFormVisible"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :fullscreen="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
      >
        <el-row :gutter="24" v-if="activityData.joinType == 1">
          <el-col :span="24">
            <el-form-item label="活动角色" prop="roleId">
              <el-select v-model="ruleForm.roleId" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.roleId"
                  :label="item.name"
                  :value="item.roleId"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterTextSignUp"
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="EqualDiv pt-2">
          <el-col
            :span="10"
            class="divTreeCont"
            style="height: 300px; overflow-y: auto"
          >
            <el-tree
              :data="signUpColleges"
              :props="defaultProps"
              node-key="id"
              show-checkbox
              ref="treeSignUp"
              :filter-node-method="filterNodeJoinIn"
              default-expand-all
              @check-change="handleCheckChange"
            >
            </el-tree>
          </el-col>
          <el-col :span="4" class="VerticalMid">
            <svg class="icon iconBox" aria-hidden="true">
              <use xlink:href="#fax-arrow-left-right-alt"></use>
            </svg>
          </el-col>
          <el-col
            :span="10"
            class="divTreeCont"
            style="height: 300px; overflow-y: auto"
          >
            <el-tree
              default-expand-all
              :data="selectTreeJoinInRanges"
              :props="defaultProps"
              node-key="id"
            >
            </el-tree>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div>
          <el-button @click="onClose()">取 消</el-button>
          <el-button type="primary" @click="onSummit()">确 定</el-button>
        </div>
      </span>
    </el-dialog>

    <el-dialog
      :title="dialogRole.title"
      :visible.sync="dialogRole.visible"
      width="30%"
      :before-close="handleRoleClose"
    >
      <span>
        <el-select
          v-model="dialogRole.roleId"
          placeholder="请选择活动角色"
          class="w-100"
          @change="handleChangeRole"
        >
          <el-option
            v-for="item in options"
            :key="item.roleId"
            :label="item.name"
            :value="item.roleId"
          >
          </el-option>
        </el-select>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleRoleClose">取 消</el-button>
        <el-button type="primary" @click="onChangeRole">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/Admin.css';
import comPage from '@/components/Page.vue';
import comImport from '@/components/Import.vue';
// import search from '@/components/search.vue';
export default {
  components: {
    comPage,
    comImport,
    // search
  },
  data() {
    return {
      //是否选择班级
      dialogFormVisible: false,
      signUpColleges: [],
      signUpCollegesReset: [],
      selectTreeJoinInRanges: [],
      selectTreeJoinInRangesReset: [],
      filterTextSignUp: '',
      signUpRanges: [], //选择的班级
      options: [], //活动角色
      ruleForm: {
        roleId: null,
        ranges: null,
      },
      // 用于全选状态
      iconAllCheck: 0, // 0:未选择 1:有选择项 2:全选
      itemData: [],
      dialogTitle: '',
      dialogVisible: false,
      SearchTitles: [],
      SearchList: null, //搜索集合
      id: null,
      parentType: null,
      fullscreenLoading: false,
      Title: null,
      ImportTitle: null,
      ImportUrl: null,
      ImportFile: null,
      page: null, //分页查询接口返回的结果
      pageBtnList: null, //分页左侧按钮集合
      paging: {
        //分页数据
        totalCount: 0,
      },
      selectRosters: [],
      // 角色
      optRoles: [],
      // 收集活动数据
      activityData: {},
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      rules: {
        roleId: [
          {
            required: true,
            message: '请选择活动角色',
            trigger: 'change',
          },
        ],
      },
      joinType: null,
      dialogRole: {
        title: '活动角色',
        visible: false,
        roleId: null,
        roleName: null,
        studentId: null,
      },
      windowHeight: 0,
      isBatchDelete: true,
    };
  },
  created() {
    let that = this;
    that.id = that.$route.params.id;
    that.parentType = that.$route.params.type;
    var detailUrl = null;
    if (that.id != null && typeof that.id != 'undefined' && that.id != '') {
      detailUrl = '/api/admin/activity/' + that.id;
    }
    that.fullscreenLoading = true;

    ajaxGet(that, '/api/admin/activityrole', null, function (resRole) {
      if (!regNullArray(resRole)) {
        that.options = resRole;
      }
      ajaxGet(that, detailUrl, null, function (r) {
        if (r != null) {
          // 获取
          that.activityData = r;
          that.Title = r.name;
          // 获取这个活动勾选的几个角色
          for (let item of r.configs) {
            that.optRoles.push({
              value: item.roleId,
              label: item.roleName,
            });
          }
          that.ruleForm.roleId = r.roleId;
          that.optRoles = that.onArrUnique(that.optRoles);
          // if (r.isApply) {
          //   that.Title = that.Title + '【确认最终名单】';
          //   that.ImportTitle = '导入报名名单';
          //   that.ImportUrl = '/api/admin/activity/registerroster/' + that.id;
          //   that.ImportFile = '/Templates/活动名单导入模版.xlsx';
          // } else if (r.isApply == false && r.isUpload == true) {
          //   that.Title = that.Title + '【确认最终名单】';
          //   that.ImportTitle = '导入参与名单';
          //   that.ImportUrl = '/api/admin/activity/registerroster/' + that.id;
          //   that.ImportFile = '/Templates/活动名单导入模版.xlsx';
          // }
          that.Title = that.Title + '【确认最终名单】';
          that.ImportTitle = '导入参与名单';
          that.ImportUrl = '/api/admin/activity/participateroster/' + that.id;
          that.ImportFile = '/Templates/活动名单导入模版.xlsx';
        }
        that.fullscreenLoading = false;
      });
      pagingPage(that);
    });
  },
  mounted() {
    let that = this;
    // 页面挂载完成后获取高度
    that.windowHeight = window.innerHeight - 300;
  },
  methods: {
    /**
     * @description 勾选删除名单
     */
    onCheckDelType(objItem) {
      let that = this;
      // 使用 $set 强制触发 Vue 响应式更新
      if (regNull(objItem.delType) || objItem.delType == false) {
        that.$set(objItem, 'delType', true);
      } else {
        that.$set(objItem, 'delType', false);
      }

      // 设置全选状态
      if (
        that.itemData.every(
          (item) => !regNull(item.delType) && item.delType == true
        )
      ) {
        that.iconAllCheck = 2;
        that.isBatchDelete = false;
      } else if (
        that.itemData.some(
          (item) => !regNull(item.delType) && item.delType == true
        )
      ) {
        that.iconAllCheck = 1;
        that.isBatchDelete = false;
      } else {
        that.iconAllCheck = 0;
        that.isBatchDelete = true;
      }
    },
    /**
     * @description 批量移除名单
     */
    onBatchDel() {
      let that = this;
      let tpParams = that.itemData
        .filter(function (item) {
          return !regNull(item.delType) && item.delType == true;
        })
        .map((item) => item.rosterId);

      setTimeout(() => {
        if (!regNullArray(tpParams)) {
          confirmDelete(
            that,
            `您确定要移除名单中的【${tpParams.length}】名学生吗？移除后信息将无法恢复，请谨慎操作`,
            function (res) {
              if (res == true) {
                that.fullscreenLoading = true;
                ajaxPut(
                  that,
                  '/api/admin/activity/deleteroster',
                  tpParams,
                  function (r) {
                    that.fullscreenLoading = false;
                    pagingPage(that);
                  }
                );
              }
            }
          );
        }
      }, 200);
    },
    /**
     * @description 移除学生名单
     */
    onDeleteRoster(objItem) {
      let that = this;
      let tpParams = [objItem.rosterId];
      confirmDelete(
        that,
        `您确定要移除名单中【${objItem.studentName}】吗？ 移除后信息将无法恢复，请谨慎操作`,
        function (res) {
          if (res == true) {
            that.fullscreenLoading = true;
            ajaxPut(
              that,
              '/api/admin/activity/deleteroster',
              tpParams,
              function (r) {
                that.fullscreenLoading = false;
                pagingPage(that);
              }
            );
          }
        }
      );
    },
    handleRoleClose() {
      let that = this;
      that.dialogRole.visible = false;
      that.dialogRole.roleId = null;
      that.dialogRole.roleName = null;
      that.dialogRole.studentId = null;
      that.dialogRole.title = '活动角色';
    },
    handleChangeRole(objItem) {
      let that = this;
      let tempInfo = that.options.find((item) => item.roleId == objItem);
      that.dialogRole.roleName = tempInfo ? tempInfo.name : null;
    },
    /**
     * @description 选择活动角色
     */
    onClickRole(objItem) {
      let that = this;
      that.dialogRole.visible = true;
      that.dialogRole.roleId = objItem.roleId;
      that.dialogRole.title = `【${objItem.studentName}】活动角色`;
      that.dialogRole.studentId = objItem.studentId;
    },
    /**
     * @description 确认活动角色
     */
    onChangeRole() {
      let that = this;
      let icount = 0;

      for (var item of that.itemData) {
        if (item.studentId == that.dialogRole.studentId) {
          item.roleId = that.dialogRole.roleId;
          item.roleName = that.dialogRole.roleName;
          break; // 匹配成功后立即退出，符合预期
        }
      }
      that.handleRoleClose();
    },
    /**
     * @description 是否计入综合分
     */
    onIsStatus(objItems, objStatus) {
      objItems.status = objStatus ? 3 : 2;
    },
    // 去除重复性数据
    onArrUnique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.label) && res.set(arr.label, 1));
    },
    /**
     * @description 全选
     */
    onCheckAll() {
      let that = this;
      let tempStatus = false;
      if (that.iconAllCheck == 0 || that.iconAllCheck == 1) {
        tempStatus = true;
        that.iconAllCheck = 2;
        that.isBatchDelete = false;
      } else {
        tempStatus = false;
        that.iconAllCheck = 0;
        that.isBatchDelete = true;
      }

      that.$nextTick(function () {
        that.itemData.forEach((item) => {
          if (!item.scoring) {
            that.$set(item, 'delType', that.iconAllCheck == 2 ? true : false);
          }
        });
      });
    },
    onImportSuccess(param) {
      let that = this;
      pagingPage(that);
    },
    handleCheckChange(data, checked, indeterminate) {
      let that = this;
      if (data.parentId != '00000000-0000-0000-0000-000000000000') {
        if (
          checked == true &&
          data.id != null &&
          typeof data.id != 'undefined'
        ) {
          if (data.id != '00000000-0000-0000-0000-000000000000') {
            that.signUpRanges.push(data.id);
          }
        } else if (
          checked == false &&
          data.id != null &&
          typeof data.id != 'undefined'
        ) {
          let newRanges = that.signUpRanges.filter((item, index, arr) => {
            return item != data.id;
          });
          that.signUpRanges = newRanges;
        }
        that.selectSigeUpRanges = [];
        for (var classId of that.signUpRanges) {
          GetSelectSigeUpRanges(that, classId);
        }
        that.selectTreeJoinInRanges = [];
        that.selectTreeJoinInRanges = toTreeByRecursion(
          that.selectSigeUpRanges,
          'id',
          'parentId',
          null,
          'children'
        );
        that.selectTreeJoinInRangesReset = JSON.parse(
          JSON.stringify(that.selectTreeJoinInRanges)
        );
      }
    },
    //取消
    onClose() {
      let that = this;
      that.dialogFormVisible = false;
    },
    //确认
    onSummit() {
      let that = this;
      if (regNullArray(that.signUpRanges)) {
        warning(that, '请选择班级');
        return false;
      }
      that.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          that.fullscreenLoading = true;
          ajaxPut(
            that,
            '/api/admin/activity/addparticipateroster?activityId=' +
              that.id +
              '&roleId=' +
              that.ruleForm.roleId,
            that.signUpRanges,
            function (res) {
              that.dialogFormVisible = false;
              that.fullscreenLoading = false;
              ajaxGet(
                that,
                '/api/admin/activity/roster/' + that.id,
                null,
                function (r1) {
                  that.itemData = r1;
                  that.paging.totalCount = r1.length;
                  for (var it of r1) {
                    it.images = [];
                    if (it.attachment != null && it.attachment != '') {
                      var images = it.attachment.split('|');
                      for (var it1 of images) {
                        it.images.push(that.$ServerUrl() + it1);
                      }
                    }
                  }
                }
              );
            }
          );
        }
      });
    },
    filterNodeJoinIn(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //选择名单
    onAdd() {
      let that = this;
      let resArrUnique = new Map();
      ajaxGet(
        that,
        '/api/admin/sysuser/userfilternograduate',
        null,
        function (resultClass) {
          let arrCollege = [];
          resultClass
            .filter(
              (arr) =>
                !resArrUnique.has(arr.collegeId) &&
                resArrUnique.set(arr.collegeId, 1)
            )
            .forEach(function (item) {
              arrCollege.push({
                name: item.college,
                id: item.collegeId,
                parentId: '00000000-0000-0000-0000-000000000000',
                children: [],
              });
            });
          arrCollege.forEach((item) => {
            for (var it of resultClass) {
              if (it.collegeId == item.id) {
                item.children.push({
                  id: it.classId,
                  name: it.alias,
                  parentId: it.collegeId,
                  children: [],
                });
              }
            }
          });
          that.colleges = [
            {
              id: '00000000-0000-0000-0000-000000000000',
              name: '全校学生',
              children: arrCollege,
              parentId: null,
            },
          ];
          that.allColleges = [];
          InitCollege(that, that.colleges);
          that.signUpColleges = JSON.parse(JSON.stringify(that.colleges));
          that.signUpCollegesReset = JSON.parse(
            JSON.stringify(that.signUpColleges)
          );
          try {
            that.$refs['ruleForm'].resetFields();
          } catch {}
          that.selectTreeJoinInRanges = [];
          that.fullscreenLoading = false;
        }
      );
      that.dialogFormVisible = true;
    },
    /**
     * @description 计入综合分
     */
    onSave() {
      let that = this;
      var rosterIds = [];
      for (var it of that.itemData) {
        if (it.status == 3 && !it.scoring) {
          // 计入综合分的数组
          rosterIds.push({
            rosterId: it.rosterId,
            roleId: it.roleId,
          });
        }
      }
      var title = '';
      if (rosterIds != null && rosterIds.length != 0) {
        title =
          '计入综合分是活动的最终操作流程，完成后确认通过的学生将增加相应的综合分数，但不能再调整活动名单和编辑、修改、删除等操作，是否确定？';
        confirm(that, title, function () {
          that.fullscreenLoading = true;

          ajaxPut(
            that,
            '/api/admin/activity/ParticipateConfirm/' + that.id,
            rosterIds,
            function (r) {
              that.fullscreenLoading = false;
              that.onBack();
            }
          );
        });
      } else {
        title = '当前没有选择人员计入综合分!';
        warning(that, title);
      }
    },
    onBack() {
      let that = this;
      back(that);
    },
    pageBtnClick(index) {
      //分页组件左侧的按钮事件，按顺序进行判断
    },
    onSearch(params) {
      let that = this;
      let data = {};
      let searchData = params;
      searchData.forEach((element) => {
        if (element.data) {
          data[element.zhi] = element.data;
        }
      });
      data['url'] = that.$route.query.url;
      data.PageNumer = 1;
      routerPath(
        that,
        '/Admin/activity/roster/' + that.parentType + '/' + that.id,
        data,
        null,
        'PageSize'
      );
    },
    pagingClick(type, val) {
      let that = this;
      let url = '/Admin/activity/roster/' + that.parentType + '/' + that.id;
      if (type == 1) {
        //更改每页条数触发的事件
        routerPath(
          that,
          url,
          'PageSize',
          val,
          'PageNumer',
          'Name',
          'ClassId',
          'StudentNo',
          'url'
        );
      } else {
        //更改当前页时触发的事件
        routerPath(
          that,
          url,
          'PageNumer',
          val,
          'PageSize',
          'Name',
          'ClassId',
          'StudentNo',
          'url'
        );
      }
    },
  },
  watch: {
    $route() {
      let that = this;
      pagingPage(that);
    },
    filterTextSignUp(val) {
      this.$refs.treeSignUp.filter(val);
    },
  },
};
function GetSelectSigeUpRanges(that, objID) {
  let temp = that.allColleges.find((item) => item.id == objID);
  if (temp != undefined) {
    if (
      that.selectSigeUpRanges.find((item) => item.id == temp.id) == undefined
    ) {
      that.selectSigeUpRanges.push(temp);
      if (!regNull(temp.parentId)) {
        GetSelectSigeUpRanges(that, temp.parentId);
      }
    }
  }
}
function InitCollege(that, val) {
  if (val.length !== 0) {
    val.forEach((item) => {
      that.allColleges.push(item);
      if (
        item.children != null &&
        typeof item.children != 'undefined' &&
        item.children.length >= 1
      ) {
        InitCollege(that, item.children);
      }
    });
  }
}

function pagingPage(that) {
  paging(
    that,
    function (r) {
      that.SearchList = [
        {
          type: 'input',
          Name: '班级',
          data: r.ClassId,
          holder: '请输入班级',
          zhi: 'ClassId',
        },
        {
          type: 'input',
          Name: '姓名',
          data: r.Name,
          holder: '请输入学生姓名',
          zhi: 'Name',
        },
        {
          type: 'input',
          Name: '学号',
          data: r.StudentNo,
          holder: '请输入学号',
          zhi: 'StudentNo',
        },
      ];

      let data = {
        StudentNo: r.StudentNo,
        Name: r.Name,
        ClassId: r.ClassId,
      };

      ajaxGet(
        that,
        '/api/admin/activity/roster/' + that.id,
        null,
        function (r1) {
          let tempArr = [];
          // 判断是否签到
          if (that.activityData.isAttendance) {
            // 需要签到
            tempArr = r1.filter((item) => item.attended == true);
          } else {
            //不需要签到
            tempArr = r1.filter((item) => item.status == 3);
          }

          that.itemData = r1;
          that.paging.totalCount = tempArr.length;
          for (var it of tempArr) {
            it.images = [];
            if (it.attachment != null && it.attachment != '') {
              var images = it.attachment.split('|');
              for (var it1 of images) {
                it.images.push(that.$ServerUrl() + it1);
              }
            }
          }
        }
      );
    },
    'Name',
    'StudentNo',
    'ClassId'
  );
}
</script>

<style scoped="scoped" lang="less">
.table-box {
  overflow-y: auto;
}
.table-body {
  border-top: 1px solid #ebeef5;
  width: 100%;
  tr {
    border-bottom: 1px solid #ebeef5;
    &:hover {
      background-color: #f4f6f9;
    }
    &:nth-child(even) {
      background-color: #fafafa;
    }
  }
  .tr-head {
    td {
      padding: 12px 10px;
      color: #909399;
      font-weight: 500;
      font-size: 14px;
    }
  }
  .tr-body {
    td {
      padding: 12px 10px;
      font-weight: 400;
      font-size: 14px;
      color: #606266;
    }
    .td-checkbox {
      cursor: pointer;
    }
  }

  .btn-xs {
    padding: 3px 10px;
    font-size: 12px;
  }
  .btn-disable {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.td-select-box {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 2px 4px;
  display: flex;
  cursor: pointer;
  .icon {
    flex: 1;
  }
}

.td-status {
  display: flex;
  justify-self: space-between;
  .td-status-item {
    width: 100%;
    cursor: pointer;
    .icon {
      margin-right: 5px;
    }
    .td-status-yes {
      display: none;
    }
    .td-status-no {
      display: block;
    }
  }
  .td-status-action {
    color: #409eff;
    .td-status-yes {
      display: block;
    }
    .td-status-no {
      display: none;
    }
  }
}

.divTreeCont {
  border: 1px solid #dddddd;
  border-radius: 5px;
  padding: 15px;
  min-height: 150px;
}
</style>
